import {
    post
} from './request'

/** 信息公开--栏目列表 */
export const getCategoryXinxiGongkai = data => post('/index/mg_open_cate_list', data)
// 信息公开--栏目下文章列表
export const getCategoryXinxiGongkaiPage = data => post('/index/mg_open_article_list', data)
// 信息公开--栏目文章详情
export const getCategoryXinxiGongkaiItem = data => post('/index/gm_open_cate_detail', data)
// 信息公开--栏目下文章列表--详情页 
export const getCategoryXinxiGongkaiDetail = data => post('/index/gm_open_article_detail', data)
// 
export const cate_artile_list = data => post('/index/cate_artile_list', data)
